import { useFocus } from '@vueuse/core';
import { defineComponent, ref, toRefs, computed } from 'vue-demi';
import './TimeFormat-a7f5565b.js';
import './dom-53c9635b.js';
import { u as useProxyModelValue } from './useProxyModelValue-e18f251e.js';
import '@onereach/styles/screens.json';
import '@onereach/styles/tailwind.config.json';
import { withDirectives, openBlock, createElementBlock, normalizeStyle, normalizeClass, vModelDynamic } from 'vue';

const SelectControlInput = [
// Base
'appearance-none',
// Typography
'typography-inherit',
// Theme (placeholder)
'placeholder:theme-foreground-outline', 'dark:placeholder:theme-foreground-outline-dark', 'theme-background-transparent', 'outline-none'];

var script = defineComponent({
  name: 'OrSelectControlInput',
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  expose: ['root', 'focus', 'focused'],
  setup(props, context) {
    // Refs
    const root = ref();
    // Props
    const {
      placeholder,
      modelValue
    } = toRefs(props);
    // State
    const proxyModelValue = useProxyModelValue(modelValue, context.emit);
    const {
      focused
    } = useFocus(root);
    // Styles
    const controlStyles = computed(() => [...SelectControlInput]);
    const controlInlineStyles = computed(() => {
      var _a;
      const chars = proxyModelValue.value.length > 0 ? proxyModelValue.value.length : (_a = placeholder.value) === null || _a === void 0 ? void 0 : _a.length;
      return {
        width: `${Math.max(chars + 1 || 0, 2)}ch`
      };
    });
    // Methods
    function focus() {
      focused.value = true;
    }
    return {
      root,
      proxyModelValue,
      controlStyles,
      controlInlineStyles,
      focused,
      focus
    };
  }
});

const _hoisted_1 = ["placeholder", "readonly", "disabled"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  return withDirectives((openBlock(), createElementBlock("input", {
    ref: 'root',
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.proxyModelValue = $event),
    style: normalizeStyle(_ctx.controlInlineStyles),
    class: normalizeClass(_ctx.controlStyles),
    type: 'text',
    placeholder: _ctx.placeholder,
    readonly: _ctx.readonly,
    disabled: _ctx.disabled,
    autocomplete: 'off',
    minlength: undefined,
    maxlength: undefined
  }, null, 14 /* CLASS, STYLE, PROPS */, _hoisted_1)), [[vModelDynamic, _ctx.proxyModelValue]]);
}

script.render = render;
script.__file = "src/components/or-select-v3/partials/or-select-control-input/OrSelectControlInput.vue";

export { script as s };
